export default __webpack_public_path__ + "static/media/perfilSinFoto.d06f1ec7.png";